import React, { Component } from 'react';
import AccesoSimultaneoItem from "./AccesoSimultaneoItem";

const AccesoSimultaneo = (props) => {
    let plataformas = props.plataformas.map(function (plataforma) {
        return (
            <div className="">
                <AccesoSimultaneoItem value={plataforma.CanLog}
                    message={plataforma.Descripcion}
                    extencion=" "
                    textChangeState={props.textChangeState}
                    plataformaValueChange={props.plataformaValueChange}/>
            </div>
        );
    });

    return (
        <div className="">
            <div>
                <h5 className="configuration-view-subtitle">Accesos máximos simultáneos por tipo de plataforma (defeault):</h5>
            </div>
            {plataformas}
        </div>
    );
};

export default AccesoSimultaneo;

